import * as React from "react";

const SvgBgmoon = (props) => (
  <svg
    viewBox="0 0 840 840"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={420} cy={420} r={420} fill="#F1F0FF" fillOpacity={0.06} />
    <circle cx={420} cy={420} r={310.685} fill="#F1F0FF" fillOpacity={0.15} />
    <circle cx={420} cy={420} r={218.63} fill="#F1F0FF" fillOpacity={0.35} />
    <circle cx={420} cy={420} r={133.479} fill="#F1F0FF" fillOpacity={0.65} />
  </svg>
);

export default SvgBgmoon;
